// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_28OBD","dot":"_1xdg5","tooltip-content":"_1XdZ9","tooltipContent":"_1XdZ9"};